import { render } from "./NursingBody.vue?vue&type=template&id=2b3dbbbe"
import script from "./NursingBody.vue?vue&type=script&lang=js"
export * from "./NursingBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__